export default "__VITE_ASSET__BlJJszmh__"